import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

const LandingPage = () => {
  const navigate = useNavigate();
  const [announcement, setAnnouncement] = useState(null);
  const [ads, setAds] = useState([]);
  const [currentAdIndex, setCurrentAdIndex] = useState(0);

  useEffect(() => {
    fetchAnnouncement();
    fetchAds();
  }, []);

  useEffect(() => {
    if (ads.length > 1) {
      const interval = setInterval(() => {
        setCurrentAdIndex((prev) => (prev + 1) % ads.length);
      }, 5000); // Change ad every 5 seconds
      return () => clearInterval(interval);
    }
  }, [ads]);

  const fetchAnnouncement = async () => {
    try {
      const response = await axios.get(`${API}/announcements/active`);
      if (response.data) {
        setAnnouncement(response.data);
      }
    } catch (error) {
      console.error('Error fetching announcement:', error);
    }
  };

  const fetchAds = async () => {
    try {
      const response = await axios.get(`${API}/ads/active`);
      setAds(response.data || []);
    } catch (error) {
      console.error('Error fetching ads:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-ltb-br relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_bc6efd8f-02f7-4fdc-a397-f7bf259d1836/artifacts/uov20vz1_Pattern%20LTB.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}></div>
      
      {/* Content */}
      <div className="relative z-10">
        {/* Header - Sebelum Login */}
        <header className="bg-white shadow-md py-4 px-6">
          <div className="max-w-7xl mx-auto flex justify-between items-center">
            <div className="flex items-center space-x-3">
              <img 
                src="https://twdhwrrzphgfksbrcsfl.supabase.co/storage/v1/object/public/logo/logoLTB.png" 
                alt="LTB+" 
                className="h-12"
              />
            </div>
            <button
              onClick={() => navigate('/login')}
              className="bg-gradient-ltb-r text-white px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all"
            >
              Login
            </button>
          </div>
        </header>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 py-6">
          {/* Announcement Banner - Single Image */}
          <div className="bg-white rounded-2xl shadow-xl mb-6 overflow-hidden">
            {announcement ? (
              <div className="relative">
                <img 
                  src={announcement.gambar_mobile && window.innerWidth < 768 ? announcement.gambar_mobile : announcement.gambar_url} 
                  alt="Announcement" 
                  className="w-full h-40 sm:h-64 object-cover"
                />
              </div>
            ) : (
              <div className="bg-gradient-ltb text-white py-8 sm:py-16 px-4 sm:px-8 text-center">
                <h1 className="text-2xl sm:text-4xl font-bold mb-2 sm:mb-4">Announcement</h1>
                <p className="text-base sm:text-xl">(Belum ada announcement)</p>
              </div>
            )}
          </div>

          {/* Menu Grid - 8 Buttons (2x4 Layout) */}
          <div className="bg-white rounded-2xl shadow-xl p-6 mb-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {/* Registrasi */}
              <button
                onClick={() => navigate('/login')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white transition-all shadow-md"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span className="font-bold text-sm">Registrasi</span>
              </button>

              {/* Video */}
              <button 
                onClick={() => navigate('/video')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white transition-all shadow-md"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
                <span className="font-bold text-sm">Video</span>
              </button>

              {/* Pertandingan - hidden */}
              {/* Statistik - hidden */}

              {/* Berita */}
              <button
                onClick={() => navigate('/berita')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white transition-all shadow-md"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
                <span className="font-bold text-sm">Berita</span>
              </button>

              {/* Galeri - requires login */}
              <button 
                onClick={() => navigate('/login')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white transition-all shadow-md"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                <span className="font-bold text-sm">Galeri</span>
              </button>

              {/* Tiket */}
              <button 
                onClick={() => navigate('/login')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white shadow-md transition-all"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                </svg>
                <span className="font-bold text-sm">Tiket</span>
              </button>

              {/* Bantuan */}
              <button 
                onClick={() => navigate('/faq')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium rounded-xl p-3 flex flex-col items-center justify-center hover:bg-ltb-medium hover:text-white shadow-md transition-all"
              >
                <svg className="w-6 h-6 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="font-bold text-sm">Bantuan</span>
              </button>
            </div>
          </div>

          {/* Ads Carousel */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
            {ads.length > 0 ? (
              <>
                <div className="bg-gray-100 rounded-xl h-48 overflow-hidden">
                  {ads[currentAdIndex].link ? (
                    <a 
                      href={ads[currentAdIndex].link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="block w-full h-full cursor-pointer hover:opacity-90 transition-opacity"
                    >
                      <img 
                        src={ads[currentAdIndex].gambar_mobile && window.innerWidth < 768 ? ads[currentAdIndex].gambar_mobile : ads[currentAdIndex].gambar_url} 
                        alt={`Ad ${currentAdIndex + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </a>
                  ) : (
                    <img 
                      src={ads[currentAdIndex].gambar_mobile && window.innerWidth < 768 ? ads[currentAdIndex].gambar_mobile : ads[currentAdIndex].gambar_url} 
                      alt={`Ad ${currentAdIndex + 1}`}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="flex justify-center mt-4 space-x-2">
                  {ads.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentAdIndex(index)}
                      className={`w-3 h-3 rounded-full transition-all ${
                        currentAdIndex === index ? 'bg-ltb-deep' : 'bg-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </>
            ) : (
              <div className="bg-gradient-ltb rounded-xl h-48 flex items-center justify-center text-white">
                <p className="text-2xl font-bold">Belum ada iklan</p>
              </div>
            )}
          </div>

          {/* Footer Buttons */}
          <div className="bg-white rounded-2xl shadow-xl p-6">
            <div className="grid grid-cols-2 gap-4">
              <button
                onClick={() => navigate('/login')}
                className="bg-gradient-ltb-r text-white py-4 rounded-xl font-bold text-lg hover:shadow-xl transition-all"
              >
                Login
              </button>
              <button
                onClick={() => navigate('/register')}
                className="bg-white border-2 border-ltb-medium text-ltb-medium py-4 rounded-xl font-bold text-lg hover:bg-ltb-medium hover:text-white transition-all"
              >
                Register
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
